import { Action } from '@ngrx/store';

export class StockIpoOfferingAction implements Action {

    public static getAllIpoOfferings = '[IPOs] get_all_ipos_offerings';
    public static getAllIpoOfferingsError = '[IPOs] get_all_ipos_offerings_error';
    public static getAllIpoOfferingsSuccess = '[IPOs] get_all_ipos_offerings_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
